import { useMemo } from "react";
import { useSelector } from "../../../redux/hooks";
import {
    currentRolesSelector,
    currentUserEmailSelector,
} from "../../../redux/slices/auth/selectors";
import {
    isUserClaimApprover,
    isUserPaymentApprover,
} from "../../../utils/role";
import { BesuProjectState } from "../../../types/project";

/**
    If the current user role is CLAIM_APPROVER or PAYMENT_ORDER_APPROVER, 
    it is necessary to determine whether the current user is an approver of this project.
    => If not, should redirected when they try to access the projects route by url
 */

const useHasCurrentUserProjectRouteAccess = (
    project: BesuProjectState | undefined,
) => {
    const currentRoles = useSelector(currentRolesSelector);
    const currentUserEmail = useSelector(currentUserEmailSelector);

    const isUserHasEnterProjectAccess: boolean = useMemo(() => {
        if (project) {
            if (isUserClaimApprover(currentRoles)) {
                return project.claimApprovers.some(
                    (it) => it.email === currentUserEmail,
                );
            } else if (isUserPaymentApprover(currentRoles)) {
                return project.paymentOrderApprovers.some(
                    (it) => it.email === currentUserEmail,
                );
            } else {
                return true;
            }
        } else {
            return false;
        }
    }, [currentRoles, currentUserEmail, project]);

    return isUserHasEnterProjectAccess;
};

export default useHasCurrentUserProjectRouteAccess;
